import { useEffect, useState } from "react";

interface UseAudioTimerProps {
  audioDetected: boolean;
}

interface UseAudioTimerReturn {
  speakingDuration: number;
  stopTimer: () => number;
  resetAudioTimer: () => void;
}

const useAudioTimer = ({
  audioDetected,
}: UseAudioTimerProps): UseAudioTimerReturn => {
  const [speakingDuration, setSpeakingDuration] = useState<number>(0);

  const [recordingStartTime, setRecordingStartTime] = useState<number | null>(
    null
  );
  const [speakingStartTime, setSpeakingStartTime] = useState<number | null>(
    null
  );

  const reset = () => {
    console.log("Resetting audio timer");
    setSpeakingDuration(0);
    setRecordingStartTime(null);
    setSpeakingStartTime(null);
  };

  const stopTimer = (): number => {
    if (recordingStartTime == null) return 0;
    return Date.now() - recordingStartTime;
  };

  useEffect(() => {
    if (audioDetected) {
      // Initialize recording time, should happen once per interaction
      if (recordingStartTime === null) {
        setRecordingStartTime(Date.now());
      }
      // Initialize speaking time, could happen many times interaction (pauses)
      if (speakingStartTime === null) {
        setSpeakingStartTime(Date.now());
      }
    } else {
      // Accumulate speaking duration when audio is no longer detected
      if (speakingStartTime !== null) {
        const elapsed = Date.now() - speakingStartTime;
        setSpeakingDuration((prev) => prev + elapsed);
        setSpeakingStartTime(null);
      }
    }
  }, [audioDetected]);

  return {
    speakingDuration: speakingDuration,
    resetAudioTimer: reset,
    stopTimer: stopTimer,
  };
};

export default useAudioTimer;
